<template>
  <div class="min-w-[150px]">
    <RevLink
      class="text-left"
      :data-test="`orderDetailsButton_${order.id}`"
      @click="handleClickOrderId"
    >
      <span class="tabular-nums">{{ order.id }}</span>
      <span class="invisible group-hover:visible">
        - {{ i18n(translations.seeDetails) }}</span
      >
    </RevLink>
    <div v-if="isValidDate" data-allow-mismatch>
      {{ i18n.date(new Date(order.creationDate), DATE_TIME_MINUTES_FORMAT) }}
    </div>
    <div class="body-2-bold flex flex-row">
      <Flag class="mr-8" :country-code="order.market" />
      {{
        i18n(translations.fullName, {
          firstName: order.client.firstName,
          lastName: order.client.lastName,
        })
      }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

import { DATE_TIME_MINUTES_FORMAT } from '~/constants/dateTimeFormats'

import type { Order } from '../../../../Tab.types'
import { useOrderRecapDrawer } from '../../composables/useOrderRecapDrawer'

import translations from './OrderCell.translations'

const i18n = useI18n()
const { openOrderDetails } = useOrderRecapDrawer()

const props = defineProps<{ order: Order }>()

const isValidDate = computed(() => Date.parse(props.order.creationDate))

async function handleClickOrderId() {
  await openOrderDetails(props.order.id)
}
</script>
